export const fromInvoiceTermsFields = {
  AGREE: 'agree',
};
